import { prefix } from 'inline-style-prefixer';
// let scrollBarWidth;
const isServer = typeof window === 'undefined';
const SPECIAL_CHARS_REGEXP = /([:\-_]+(.))/g;
const MOZ_HACK_REGEXP = /^moz([A-Z])/;
const ieVersion = isServer ? 0 : Number(document.documentMode);

const camelCase = function(name) {
  // eslint-disable-next-line
  return name.replace(SPECIAL_CHARS_REGEXP, (_, separator, letter, offset) => offset ? letter.toUpperCase() : letter).replace(MOZ_HACK_REGEXP, 'Moz$1');
};

const getStyle = ieVersion < 9 ? function(element, _styleName) {
  let styleName = _styleName;
  if (isServer) return;
  if (!element || !styleName) return null;
  styleName = camelCase(styleName);
  if (styleName === 'float') {
    styleName = 'styleFloat';
  }
  try {
    switch (styleName) {
      case 'opacity':
        try {
          return element.filters.item('alpha').opacity / 100;
        } catch (e) {
          return 1.0;
        }
      default:
        return (element.style[styleName] || element.currentStyle ? element.currentStyle[styleName] : null);
    }
  } catch (e) {
    return element.style[styleName];
  }
} : function(element, _styleName) {
  let styleName = _styleName;
  if (isServer) return;
  if (!element || !styleName) return null;
  styleName = camelCase(styleName);
  if (styleName === 'float') {
    styleName = 'cssFloat';
  }
  try {
    const computed = document.defaultView.getComputedStyle(element, '');
    return element.style[styleName] || computed ? computed[styleName] : null;
  } catch (e) {
    return element.style[styleName];
  }
};

const isScroll = (el, vertical) => {
  if (isServer) return;

  const determinedDirection = vertical !== null || vertical !== undefined;
  // eslint-disable-next-line
  const overflow = determinedDirection
    ? vertical
      ? getStyle(el, 'overflow-y')
      : getStyle(el, 'overflow-x')
    : getStyle(el, 'overflow');

  return overflow.match(/(scroll|auto)/);
};

/* eslint-disable */
const easeInOutCubic = value => value < 0.5
  ? (value * 2) ** 3 / 2
  : 1 - ((1 - value) * 2) ** 3 / 2;
/* eslint-enable */

const getScroll = (target, isTop = true) => {
  const isWindow = target === window;
  const props = isTop ? 'pageYOffset' : 'PageXOffset';
  const methods = isTop ? 'scrollTop' : 'scrollLeft';

  return target[isWindow ? props : methods];
};

export default {
  css(_node, style) {
    const node = _node;
    if (node && node.nodeType === Node.ELEMENT_NODE) {
      const prefixedStyle = prefix(style);
      const autoPxAttrs = ['top', 'left', 'width', 'height'];
      // eslint-disable-next-line
      for (const key in prefixedStyle) {
        if (Object.prototype.hasOwnProperty.call(prefixedStyle, key)) {
          if (typeof prefixedStyle[key] === 'number' && autoPxAttrs.indexOf(key) > -1) {
            node.style[key] = `${prefixedStyle[key]}px`;
          } else {
            node.style[key] = prefixedStyle[key];
          }
        }
      }
    }
  },
  contains(root, n) {
    let node = n;
    while (node) {
      if (node === root) {
        return true;
      }
      if (node.tenPopupParentNode) {
        // popup 手动维护父子关系
        node = node.tenPopupParentNode;
      } else {
        node = node.parentNode;
      }
    }

    return false;
  },
  getBrowserScrollSize() {
    if (isServer) return 0;

    // if (scrollBarWidth !== undefined) return scrollBarWidth;

    const outer = document.createElement('div');
    outer.className = 'el-scrollbar__wrap';
    outer.style.visibility = 'hidden';
    outer.style.width = '100px';
    outer.style.position = 'absolute';
    outer.style.top = '-9999px';
    document.body.appendChild(outer);

    const widthNoScroll = outer.offsetWidth;
    outer.style.overflow = 'scroll';

    const inner = document.createElement('div');
    inner.style.width = '100%';
    outer.appendChild(inner);

    const widthWithScroll = inner.offsetWidth;
    outer.parentNode.removeChild(outer);
    // scrollBarWidth = widthNoScroll - widthWithScroll;
    const scrollBarWidth = widthNoScroll - widthWithScroll;

    return scrollBarWidth;
  },

  scrollTo(_target, { top = 0, time } = {}) {
    const target = _target;
    const superScrollBehavior = 'scrollBehavior' in target.style;

    if (time || !superScrollBehavior) {
      const startTime = Date.now();
      const startScrollTop = getScroll(target);
      const totalOffset = startScrollTop - top;

      if (target.__tenDesignScrollRefId) {
        window.cancelAnimationFrame(target.__tenDesignScrollRefId);
      }

      const frameFunc = () => {
        const progress = (Date.now() - startTime) / (time || 450);

        if (progress < 1) {
          target.scrollTop = startScrollTop - (totalOffset * easeInOutCubic(progress));
          window.requestAnimationFrame(frameFunc);
        } else {
          target.scrollTop = top;
        }
      };

      target.__tenDesignScrollRefId = window.requestAnimationFrame(frameFunc);
    } else {
      target.scrollTo({
        top,
        behavior: 'smooth',
      });
    }
  },

  getScroll,

  getScrollContainer(el, vertical) {
    if (isServer) return;

    let parent = el;
    while (parent) {
      if ([window, document, document.documentElement].includes(parent)) {
        return window;
      }
      if (isScroll(parent, vertical)) {
        return parent;
      }
      parent = parent.parentNode;
    }

    return parent;
  },

  getCssWidth(_width) {
    let width = _width;
    if (typeof width === 'number') {
      width = `${width}px`;
    } else if (typeof width === 'string') {
      width = width.trim();
      if (/^[\.\d]+$/.test(width)) { // eslint-disable-line
        width = `${width}px`;
      }
    }
    return width;
  },

  setStyles(_el, styles) {
    const el = _el;
    if (!el) {
      return;
    }
    // eslint-disable-next-line
    for (const key in styles) {
      if (typeof styles[key] !== 'undefined' && styles[key] !== null) {
        el.style[key] = styles[key];
      }
    }
  },

  filterCssStyles(styles) {
    const validStyles = {};
    // eslint-disable-next-line
    for (const key in styles) {
      if (typeof styles[key] !== 'undefined' && styles[key] !== null) {
        validStyles[key] = styles[key];
      }
    }
    return validStyles;
  },
};
